import type { DraftDiagnostics } from "@capcut-srt/core";
import { useLocale } from "../providers/LocaleProvider";
import { Metric } from "./Metric";

export interface DiagnosticsPanelProps {
  /** The diagnostics data from the conversion result */
  diagnostics: DraftDiagnostics;
}

/**
 * Diagnostics panel showing structure analysis from the conversion result.
 * Displays a grid of metrics and a collapsible list of detected paths.
 */
export function DiagnosticsPanel({ diagnostics }: DiagnosticsPanelProps) {
  const { t } = useLocale();

  return (
    <section className="diagnostics-panel">
      <h2>{t("diagnostics.title")}</h2>
      <div className="diagnostics-grid">
        <Metric label="Drafts" value={String(diagnostics.draftCount)} />
        <Metric label="Text tracks" value={String(diagnostics.textTrackCount)} />
        <Metric label={t("status.subtitles")} value={String(diagnostics.textSegmentCount)} />
        <Metric label="Texts" value={String(diagnostics.textMaterialCount)} />
        <Metric label="Templates" value={String(diagnostics.textTemplateCount)} />
        <Metric label="Nested" value={String(diagnostics.nestedDraftCount)} />
      </div>
      <details>
        <summary>{t("diagnostics.paths")}</summary>
        <ul>
          {diagnostics.candidateDraftPaths.map((path) => (
            <li key={path}>{path}</li>
          ))}
        </ul>
      </details>
    </section>
  );
}
